const target = document.getElementById("RegisterForm-confirmEmail");
const btn = document.getElementById("registerSubmit");
const targetVal = document.getElementById('observe-target');
const mail = document.getElementById("RegisterForm-email");

const observer = new MutationObserver((mutations) => {
  let mailVal = mail.value;
  let mailConfirm = targetVal.innerText;
  if(mailVal != mailConfirm){
    btn.disabled = true;
  }else{
    btn.disabled = false;
  }
});

const config = {
  childList: true,
  attributes: true,
  characterData: true,
  subtree: true,
  attributeOldValue: true,
  characterDataOldValue: true
}

observer.observe(targetVal, config);

target.addEventListener(
  'input',
  (e) => {
    const val = e.target.value;
    targetVal.innerText = val;
  }
)


